import React, { useState } from 'react';
import { Switch, Route, useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Page from 'components/Page';
import Container from 'components/sidebar/Container';
import Content from 'components/sidebar/Content';
import PageContainer from 'components/PageContainer';
import getRouteKey from 'utilities/getRouteKey';
import joinPath from 'utilities/joinPath';

import LevelsSidebar from './LevelsSidebar';
import LevelSelector from './LevelSelector';
import Level from './Level';

const Levels = ({ page }) => {
    const location = useLocation();
    const match = useRouteMatch();
    const history = useHistory();
    
    const [ currentLevel, setCurrentLevel ] = useState(null); 

    const handleSidebarSelect = (level) => {
        setCurrentLevel(level);
    };

    const handleLevelSelectorSelect = (level) => {
        if (level === currentLevel) {
            history.push(joinPath(match.path, level));
        } else {
            setCurrentLevel(level);
        }
    };
    
    return (
        <Page>
            <Container>
                <LevelsSidebar currentLevel={currentLevel} isSelectorScreen={match.isExact} onSelect={handleSidebarSelect}/>
                
                <Content>
                    <PageContainer>
                        <AnimatePresence>
                            <Switch location={location} key={getRouteKey(location, match)}>
                                <Route path={match.path} exact>
                                    <LevelSelector page={page} currentLevel={currentLevel} onSelect={handleLevelSelectorSelect}/>
                                </Route>
                                
                                <Route path={joinPath(match.path, ':levelSlug')}>
                                    <Level/>
                                </Route>
                            </Switch>
                        </AnimatePresence>
                    </PageContainer>
                </Content>
            </Container>
        </Page>
    );
};

export default Levels;
